import React from "react";

function PageTitle({ children, ...rest }) {
  return (
    <div>
      <p className="inline-block w-full font-poppins text-4xl font-bold text-center mx-auto mt-8 mb-6 text-black-1" {...rest}>
        {children}
      </p>
    </div>
  );
}

export default PageTitle;
